import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import InfiniteScroll from "react-infinite-scroller";
import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import {
  FILTERS_FOR_NAMES,
  ORDER_DIR,
  QUERY_STATUS,
  TAG_TYPES,
} from "constants/constants";
import Loader from "core/loader/LoaderV2";
import { getStatusLabel } from "utils/workerHelper";
import { Link } from "react-router-dom";
import { useUserContext } from "api/user/UserProvider";
import { getWorkerProfile } from "utils/staffHelper";
import {
  getWorkerSlug,
  renderInitialLoaderOrNoResult,
  sortTriggerHelper,
} from "utils/toolsManagerHelper";
import { useEffect, useRef, useState } from "react";
import Icon from "core/icon/Icon";
import _ from "lodash";
import CategoryTag from "core/tags/category-tag/CategoryTag";
import PropTypes from "prop-types";
import Button from "core/buttons/button/Button";
import { useMissionContext } from "api/mission/MissionProvider";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import { getEntityName, getEntityIsAllowed } from "utils/helper";
import DocumentDownloadModal from "components/modal/DocumentDownloadModal";
import FloatingScrollbar from "core/floating-scrollbar/FloatingScrollbar";
import "./ClientsToolsForm.scss";

const ClientsToolsByFilter = ({
  clientsBySearch,
  loadClientStatus,
  getMoreClients,
  personsList,
  filters,
  lang,
}) => {
  const { content, total_items, page } = clientsBySearch;
  const { userScope } = useUserContext();
  const { getMissionClientCSV, clientsExcelFileStatus, setClientsExcelFileStatus } = useMissionContext();
  const { getNamesByFilters, namesByFilters } = useGeneralContext();

  const [orderDirClient, setOrderDirClient] = useState("");
  const [orderDirMission, setOrderDirMission] = useState("");
  const [order, setOrder] = useState("");

  const tableContainerRef = useRef(null);

  const header = [
    {
      label: {
        key: "client-name",
        value: (
          <>
            <FormattedMessage
              id="tools_manager_client_page_table_header_client_name"
              defaultMessage={"Nom du client"}
            />
            <Icon
              icon={sortTriggerHelper({
                header: orderDirClient,
                sortCondition: "asc",
              })}
              color={"gray-200"}
              width={20}
              height={20}
              onClick={() => {
                const orderDir =
                  orderDirClient === ORDER_DIR.ASC
                    ? ORDER_DIR.DESC
                    : ORDER_DIR.ASC;
                setOrderDirClient(orderDir);
                setOrder("client");
                getMoreClients({
                  page: 1,
                  filters: { order: "client", order_dir: orderDir },
                });
              }}
            />
          </>
        ),
      },
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_client_name",
    },

    {
      label: {
        key: "client-address",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_client_address"
            defaultMessage={"Adresse"}
          />
        ),
      },
      icon: "location",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_client_address",
    },
    {
      label: {
        key: "client-zip",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_client_zip"
            defaultMessage={"CP"}
          />
        ),
      },
      icon: "location",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_client_cp",
    },
    {
      label: {
        key: "client-city",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_client_city"
            defaultMessage={"Ville"}
          />
        ),
      },
      icon: "location",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_client_city",
    },
    {
      label: {
        key: "client-country",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_client_country"
            defaultMessage={"Pays"}
          />
        ),
      },
      icon: "location",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_client_country",
    },
    {
      label: {
        key: "mission",
        value: (
          <>
            <FormattedMessage
              id="tools_manager_client_page_table_header_mission"
              defaultMessage={"Mission"}
            />
            <Icon
              icon={sortTriggerHelper({
                header: orderDirMission,
                sortCondition: "asc",
              })}
              width={20}
              height={20}
              color={"gray-200"}
              onClick={() => {
                const orderDir =
                  orderDirMission === ORDER_DIR.ASC
                    ? ORDER_DIR.DESC
                    : ORDER_DIR.ASC;
                getMoreClients({
                  page: 1,
                  filters: { order: "mission", order_dir: orderDir },
                });
                setOrderDirMission(orderDir);
                setOrder("mission");
              }}
            />
          </>
        ),
      },
      icon: "mission",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_mission",
    },
    {
      label: {
        key: "status",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_status"
            defaultMessage={"Statut"}
          />
        ),
      },
      icon: "loading",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_status",
    },
    {
      label: {
        key: "manager",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_manager"
            defaultMessage={"Manager"}
          />
        ),
      },
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_manager",
    },
    {
      label: {
        key: "mission",
        value: (
          <FormattedMessage
            id="tools_manager_client_page_table_header_cslt_str"
            defaultMessage={"Consultants / Sous-traitants"}
          />
        ),
      },
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "tools_manager_client_page_table_header_cslt_str",
    },
  ];

  useEffect(() => {
    if (content?.length) {
      loadEntityNames(content);
    }
  }, [content]);

  const loadEntityNames = async (list) => {
    const ids = list
      ?.flatMap((elm) => [elm.mission_worker_id, elm.mission_manager_id])
      .filter(Boolean);

    await getNamesByFilters({
      types: [FILTERS_FOR_NAMES.CLIENT, FILTERS_FOR_NAMES.PERSON],
      id: ids,
    });
  };

  const formattedContent = (data) =>
    data?.map((elem) => ({
      name: (
        <Link to={`/${userScope}/client/${elem?.client_slug}`}>
          {elem?.client_name}
        </Link>
      ),
      address: elem?.client_address,
      postal_code: elem?.client_postal_code,
      city: elem?.client_city,
      country: elem?.client_country,
      mission: elem?.mission_name,
      status: getStatusLabel(elem?.mission_status),
      manager: (
        <CategoryTag
          key={1}
          type={TAG_TYPES.PEOPLE}
          label={getEntityName(elem?.mission_manager_id, namesByFilters)}
          showing={true}
          many={false}
          deleteOption={false}
          linkValue={elem?.mission_manager_id}
        />
      ),
      consultant:
        getEntityIsAllowed(elem?.mission_worker_id, namesByFilters) === false ? (
          <span>{getEntityName(elem?.mission_worker_id, namesByFilters)}</span>
        ) : (
          <Link
            to={`/${userScope}/${
              getWorkerProfile({
                workers: personsList,
                id: elem?.mission_worker_id,
              }) === "cslt"
                ? "consultant"
                : "subcontractor"
            }/${
              elem?.mission_worker_id &&
              getWorkerSlug(elem?.mission_worker_id, personsList)
            }`}
          >
            {getEntityName(elem?.mission_worker_id, namesByFilters)}
          </Link>
        ),
    }));

  const loadClients = () => {
    if (loadClientStatus !== QUERY_STATUS.LOADING) {
      getMoreClients({
        page: page + 1,
        filters: {
          order,
          order_dir:
            !_.isEmpty(order) && order === "client"
              ? orderDirClient
              : orderDirMission,
        },
      });
    }
  };

  return (
    <div className="section">
      <DocumentDownloadModal
        status={clientsExcelFileStatus}
        onClose={() => setClientsExcelFileStatus(QUERY_STATUS.INITIAL)}
      />
      <ScrollToTop />
      <div>
        {renderInitialLoaderOrNoResult({
          status: loadClientStatus,
          hasContent: content?.length,
          page,
        })}
        {content?.length > 0 && (
          <>
            <div
              className="display-flex"
              style={{
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <Typography
                className="title-3 violet text-uppercase"
                type="h2"
                label={
                  <>
                    <FormattedMessage id="results" defaultMessage="Résultats" />
                    <span>: {total_items}</span>
                  </>
                }
              />
              <div className="results">
                <div className="btn-group">
                  <Button
                    className="btn-outlined"
                    size="small"
                    color="white"
                    disabled={clientsExcelFileStatus === QUERY_STATUS.LOADING}
                    onClick={() =>
                      getMissionClientCSV({
                        filters: filters,
                        lang: lang,
                      })
                    }
                  >
                    <Icon icon="sheet" color="green" height={20} />
                    <FormattedMessage
                      id={"export_excel"}
                      defaultMessage={"Exporter en Excel"}
                    />
                  </Button>
                </div>
              </div>
            </div>
            <div className="clients-table-container" ref={tableContainerRef}>
              <InfiniteScroll
                pageStart={1}
                loadMore={loadClients}
                hasMore={content?.length < total_items}
                loader={<Loader key={page} id={page} />}
              >
                <Table
                  id={`clients-by-filter`}
                  header={header}
                  content={formattedContent(content) || []}
                  tableWidth={"100%"}
                />
              </InfiniteScroll>
            </div>
            <FloatingScrollbar targetRef={tableContainerRef} />
          </>
        )}
      </div>
    </div>
  );
};

export default ClientsToolsByFilter;

ClientsToolsByFilter.propTypes = {
  clientsBySearch: PropTypes.object,
  loadClientStatus: PropTypes.string,
  getMoreClients: PropTypes.func,
  personsList: PropTypes.array,
  filters: PropTypes.array,
  lang: PropTypes.string,
};
